import { render, staticRenderFns } from "./FormatSize.vue?vue&type=template&id=2f262af4"
import script from "./FormatSize.vue?vue&type=script&lang=js"
export * from "./FormatSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports